module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "news-item",
    on: {
      "click": function($event) {
        return _vm.onToWebView()
      }
    }
  }, [_c('div', {
    staticClass: "news-top flex-between"
  }, [(!_vm.row) ? _c('div', {
    staticClass: "news-type"
  }, [_vm._v(_vm._s(_vm.row.cate_list[0].name))]) : _c('div', {
    class: _vm.row.type == 'pic' ? 'news-type-pic news-type' : 'news-type-video news-type'
  }, [_vm._v("资讯")]), _vm._v(" "), _c('div', {
    staticClass: "news-read-count"
  }, [_vm._v(_vm._s(_vm.row.views_count) + "阅读")])]), _vm._v(" "), _c('div', {
    staticClass: "news-main"
  }, [_c('div', {
    staticClass: "news-titel-box flex-start"
  }, [_c('div', {
    staticClass: "new-title-left"
  }, [_c('image', {
    staticStyle: {
      "width": "17rpx",
      "height": "12rpx"
    },
    attrs: {
      "src": "../../static/images/icon-yinhao-1@2x.png",
      "mode": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "new-title-right"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.row.title) + "\n\t\t\t\t\t"), _c('image', {
    staticClass: "title-right-img",
    staticStyle: {
      "width": "17rpx",
      "height": "12rpx"
    },
    attrs: {
      "src": "../../static/images/icon-yinhao-2@2x.png",
      "mode": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "325rpx",
      "height": "291rpx",
      "position": "relative"
    }
  }, [_c('image', {
    staticStyle: {
      "width": "325rpx",
      "height": "291rpx",
      "border-radius": "16rpx"
    },
    attrs: {
      "src": _vm.row.pic_url,
      "mode": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pics-length"
  }, [_vm._v(_vm._s(_vm.row.pics_url.length) + "张")]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "play-btn"
  }, [_c('image', {
    staticStyle: {
      "width": "58rpx",
      "height": "58rpx"
    },
    attrs: {
      "src": "../../static/images/icon-playbtn@2x.png",
      "mode": ""
    }
  })]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-077c7a9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/collection/components/NewsItem.vue
// module id = 2178
// module chunks = 0